import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { featurePropTypes } from '../ActuatorControl/types';
import ActuatorIcon, { actuatorIconPropTypes } from '../ActuatorIcon';
import { statusColorObj } from '../../themes';
import { getActuatorStatus } from '../../utils/actuatorUtils';
import { useActuatorFeatures } from '../ActuatorControlPanel/hooks/useActuatorFeatures';

const ActuatorIconWithStatus = ({ status, ...props }) => {
  const { t } = useTranslation();

  return (
    <ActuatorIcon
      tooltipLabel={t(`components.location.status.${status}`)}
      sx={{
        color: statusColorObj[status.toLowerCase()],
        WebkitFilter: 'drop-shadow( 1px 1px 1px rgba(0, 0, 0, .7))',
        filter: 'drop-shadow( 1px 1px 1px rgba(0, 0, 0, .7)) brightness(1.75)',
      }}
      {...props}
    />
  );
};

const StatusFromActuator = ({ actuator, ...props }) => {
  const features = useActuatorFeatures(actuator.id, actuator.exposes);
  const status = getActuatorStatus(features);

  return <ActuatorIconWithStatus status={status} {...props} />;
};

const StatusFromFeatures = ({ features, ...props }) => {
  const status = getActuatorStatus(features);

  return <ActuatorIconWithStatus status={status} {...props} />;
};

const ActuatorIconWithStatusStrategy = ({ features, actuator, ...props }) => {
  if (features) return <StatusFromFeatures features={features} {...props} />;

  if (actuator) return <StatusFromActuator actuator={actuator} {...props} />;

  return null;
};

const actuatorPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  exposes: PropTypes.arrayOf(PropTypes.shape({ feature: featurePropTypes }))
    .isRequired,
});

ActuatorIconWithStatus.propTypes = {
  ...actuatorIconPropTypes,
  status: PropTypes.string.isRequired,
};

ActuatorIconWithStatusStrategy.propTypes = {
  ...actuatorIconPropTypes,
  features: PropTypes.arrayOf(featurePropTypes),
  actuator: actuatorPropTypes,
};

StatusFromFeatures.propTypes = {
  ...actuatorIconPropTypes,
  features: PropTypes.arrayOf(featurePropTypes).isRequired,
};

StatusFromActuator.propTypes = {
  ...actuatorIconPropTypes,
  actuator: actuatorPropTypes.isRequired,
};

export default ActuatorIconWithStatusStrategy;
